module.exports = __webpack_public_path__ + "img/pd_m_1_fr.4a2568a2.jpg";